import { render, staticRenderFns } from "./tongueAppearance.vue?vue&type=template&id=2dcbc72e&scoped=true"
import script from "./tongueAppearance.vue?vue&type=script&lang=ts"
export * from "./tongueAppearance.vue?vue&type=script&lang=ts"
import style0 from "./tongueAppearance.vue?vue&type=style&index=0&id=2dcbc72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbc72e",
  null
  
)

export default component.exports